import React from 'react';
import Container from "react-bootstrap/Container";
import './Banner.css';
import RateButton from './RateButton';
// import { Link } from 'react-router-dom';
// import AddDisplay from './AddDisplay';


function Banner () {
    return (
        <div>
            <Container>
                <p className='main__heading'>
                Quicklearn is a community of RTU B-Tech students from all across Rajasthan, Quicklearn is for those seeking advice and assistance with B.Tech Notes and Previous Year RTU Papers. 
                </p>
                <RateButton/>
                <p className='banner__img'>
                    <img className='banner__image' src='images/et6.jpg' alt='exam-time'/>
                </p>
            </Container>

            {/* <AddDisplay/> */}
            <hr/>
            
             <span className='made__by'>
                Made by a RTU affiliated college student for RTU students
                </span> <br/>
                
            <span className='rtu_span'><img className='rtu' src='images/rtu.jpg' alt='exam-time' /></span>
            <br/>

            <Container style={{paddingTop:'25px', paddingBottom:'2rem'}}>
                <span><img className='colleges_logo' src='images/pgc.jpg' alt='exam-time' /> </span>
                <span><img className='colleges_logo' src='images/vit.jpg' alt='exam-time' /> </span>
                <span><img className='colleges_logo' src='images/skit.png' alt='exam-time' /> </span>
                <span><img className='colleges_logo' src='images/jecrc.jpg' alt='exam-time' /> </span>
                <span><img className='colleges_logo' src='images/git.webp' alt='exam-time' /> </span>
                <span><img className='colleges_logo' src='images/arya.webp' alt='exam-time' /> </span>
                <span><img className='colleges_logo' src='images/anand.jpeg' alt='exam-time' /> </span>
                <span><img className='colleges_logo' src='images/jnu.jpg' alt='exam-time' /> </span>
                <span><img className='colleges_logo' src='images/jec.png' alt='exam-time' /> </span>
                {/* <span><img className='colleges_logo' src='images/riet.jpg' alt='exam-time' /> </span>
                <span><img className='colleges_logo' src='images/jklu.png' alt='exam-time' /> </span> */}
                <br/>
                <br/>
                
            </Container>

            <hr/>

        </div>
    );
}

export default Banner;
